var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 2C6.5 1.72386 6.72386 1.5 7 1.5L10 1.5L10 4.5C10 5.32843 10.6716 6 11.5 6L14.5 6L14.5007 9.99991C14.5008 10.2761 14.2769 10.5 14.0007 10.5L7 10.5C6.72386 10.5 6.5 10.2761 6.5 10V2ZM11.5 4V1.5L14.5 4.5L12 4.5C11.7239 4.5 11.5 4.27614 11.5 4ZM6.50045 0C5.67205 0 5.00049 0.671533 5.00045 1.49993L5.00039 3H3.5C2.67157 3 2 3.67157 2 4.5V13.5C2 14.3284 2.67157 15 3.5 15H12.25C12.6642 15 13 14.6642 13 14.25C13 13.8358 12.6642 13.5 12.25 13.5H4C3.72386 13.5 3.5 13.2761 3.5 13V5C3.5 4.72386 3.72386 4.5 4 4.5H5.00032L5.00006 10.4999C5.00003 11.3284 5.67161 12 6.50006 12H14.5007C15.3291 12 16.0007 11.3283 16.0007 10.4999L16.0001 4.62123C16 4.22346 15.842 3.84199 15.5607 3.56072L12.4393 0.43934C12.158 0.158035 11.7765 0 11.3787 0H6.50045Z",
    fill: "#009866"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopy);
export default __webpack_public_path__ + "static/media/file_copy.b0a4764c29407f8202994ef1f8c4791a.svg";
export { ForwardRef as ReactComponent };